<template>
  <div
      class="d-inline-flex align-items-center font-weight-bold"
      style="height: 38px">
    <div>{{ label }}</div>
    <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
      <template #button-content>
        <b-icon-search/>
      </template>
      <b-dropdown-text>
        <b-form-checkbox
            :checked="allSelected"
            :indeterminate="indeterminate"
            aria-describedby="flavours"
            aria-controls="flavours"
            @change="selectAll">
          <div style="width: max-content">Tout {{ allSelected ? 'désélectionner' : 'sélectionner' }}</div>
        </b-form-checkbox>
        <b-form-checkbox-group
            :checked="value"
            @input="$emit('input',$event)"
            :options="options"
            stacked>
        </b-form-checkbox-group>
      </b-dropdown-text>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name    : "SearchableLabelList",
  props   : ["label", "options", "value"],
  computed: {
    allSelected() {
      return this.$props.options?.length === this.$props.value?.length;
    },
    indeterminate() {
      return this.$props.value?.length < this.$props.options?.length && !!this.$props.value?.length;
    },
  },
  methods : {
    selectAll(checked) {

      const selected = checked ? this.$props.options
          .map(o => o.value === undefined ? o : o.value)
          .slice() : []
      this.$emit('input', selected)
    }
  },
}
</script>

<style scoped>

</style>